// import router from '../../router'
import {
  NS_DOCTORS_SEARCH,
  NS_DOCTORS_SEARCH_SUCCESS,
  NS_DOCTORS_SEARCH_FAILURE,
  NS_DOCTOR_SEARCH,
  NS_DOCTOR_SEARCH_SUCCESS,
  NS_DOCTOR_SEARCH_FAILURE,
  NS_DOCTOR_MATCHING,
  NS_DOCTOR_MATCHING_SUCCESS,
  NS_DOCTOR_MATCHING_FAILURE,
  NS_DOCTOR_AUTOCOMPLETE_CLEAR
} from './mutation-types'

export default {
  state: {
    doctors: null,
    doctor: null
  },
  getters: {
    ns_doctors: state => {
      return state.doctors
    },
    ns_doctor: state => {
      return state.doctor
    }
  },
  actions: {
    [NS_DOCTORS_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/doctors'
      var callback = () => {}
      var data = {}
      if (params.data) {
        data = params.data
      }
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_DOCTORS_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_DOCTORS_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_DOCTOR_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/doctors/' + params.data.ns_doctor
      var callback = () => {}
      var data = {}
      if (params.data) {
        data = params.data
      }
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_DOCTOR_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_DOCTOR_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_DOCTOR_MATCHING] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/doctors/matching'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiPost', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_DOCTOR_MATCHING_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_DOCTOR_MATCHING_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_DOCTOR_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(NS_DOCTOR_AUTOCOMPLETE_CLEAR)
      }, sleep)
    }
  },
  mutations: {
    [NS_DOCTORS_SEARCH_FAILURE] (state, data) {
      console.log('NS_DOCTORS_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_DOCTORS_SEARCH_SUCCESS] (state, params) {
      console.log('NS_DOCTORS_SEARCH_SUCCESS')
      state.doctors = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_DOCTOR_SEARCH_FAILURE] (state, data) {
      console.log('NS_DOCTOR_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_DOCTOR_SEARCH_SUCCESS] (state, params) {
      console.log('NS_DOCTOR_SEARCH_SUCCESS')
      state.doctor = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_DOCTOR_MATCHING_SUCCESS] (state, params) {
      console.log('NS_DOCTOR_MATCHING_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    [NS_DOCTOR_MATCHING_FAILURE] (state, data) {
      console.log('NS_DOCTOR_MATCHING_FAILURE')
    },
    [NS_DOCTOR_AUTOCOMPLETE_CLEAR] (state) {
      console.log('NS_DOCTOR_AUTOCOMPLETE_CLEAR')
      state.doctors = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ns-doctor.js